import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export const useRemoveLandingPlan = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (landingPlanId: string) => {
			try {
				await api.delete(`/management/landing/plan/remove/${landingPlanId}`);
			} catch (error) {
				throw toApiError(error, 'Erro ao remover plano da landing page');
			}
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: ['public-plans'] }),
				queryClient.invalidateQueries({ queryKey: ['management-plans'] }),
			]);
		},
	});
};
